import { showNotification } from '../common/notifications/notifications';

export const errorAlert = (message) => {
    if (message !== "Refresh token is not in database!") {
        showNotification({notificationType: 'NO_CONNECTION', orderedMessage: message});   
    }

    return {
        status: "Failed",
        message: message === "Cannot read properties of undefined (reading 'message')"
            ? "NO CONNECTION"
            : message
    };
};

export const badRequestError = (error) => {
    if (error.response) { 
        // status code out of the range of 2xx
        return errorAlert(error?.response?.data?.message);
    } else if (error.request) { 
        // The request was made but no response was received
        return errorAlert(error?.request);
    } else {
        // Error on setting up the request
        return errorAlert(error?.message);
    }
}